<template>
    <div class="box">
      <div class="loading-spinner-outer" v-if="loading">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
        </div>
      </div>
        <div class="box-content">
            <div class="flex-2xs mb-3 justify-end">
                <div class="pr-3-2xs pb-1 pb-0-2xs">
                    <a class="btn-primary" :href="`/company/${company_id}/showroom/create`">
                        Add New
                    </a>
                </div>
            </div>
          <template v-if="!loading && total_count > 0">
            <table class="table_list">
                <thead>
                <tr>
                    <th>Address</th>
                    <th>Available Products</th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(showroom, index) in showrooms">
                    <td>{{ friendly_address(showroom) }}</td>
                    <td>
                      <span v-for="epwin_system_type in showroom.epwin_system_types">
                        {{ epwin_system_type.label }},
                      </span>
                    </td>
                    <td class="td_delete">
                      <a @click.stop.prevent="deleteShowroom(showroom.id)" class="txt-danger cursor-pointer">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                    <td class="td_view">
                        <a :href='`/company/${company_id}/showroom/${showroom.id}`' class="txt-primary">
                            <i class="fa fa-eye"></i>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
            <template>
                <div class="pagination-bar wrapper mb-3 mt-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                    class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} results found
                            </div>
                        </div>
                    </div>
                </div>
            </template>
          </template>
          <template v-if="!loading && total_count === 0">
            <strong>
              No Results Found
            </strong>
          </template>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'company_id',
      'logged_in_user',
    ],
    mounted() {
      this.loadShowrooms();
    },
    data() {
      return {
        showrooms: [],
        current_page: 1,
        total_count: 0,
        total_pages: 0,
        limit: 20,
        loading: true,
      }
    },
    methods: {
      loadShowrooms: _.debounce(function() {
        axios.post('/company/loadShowrooms', {
          page_number: this.current_page,
          search_query: this.search_query,
          limit: this.limit,
          company_id: this.company_id,
        }).then((response) => {
          this.showrooms = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;
          this.loading = false;
        });
      }, 250),
      prevPage() {
        this.current_page = this.current_page - 1;
        this.loadShowrooms();
      },
      nextPage() {
        this.current_page = this.current_page + 1;
        this.loadShowrooms();
      },
      deleteShowroom(id) {
        Swal.fire({
          title: 'Are you sure you want to remove this showroom?',
          text: 'This action cannot be undone.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post('/company/delete-showroom', {
              'showroom_id': id,
            }).then((response) => {
              this.current_page = 1;
              this.loadShowrooms();
              Swal.fire({
                title: 'Showroom Deleted',
                icon: 'success',
              });
            });
          }
        });
      },
      friendly_address(showroom) {
        return [showroom.line_1, showroom.line_2, showroom.town, showroom.county, showroom.postcode].filter(Boolean).join(", ");
      }
    },
  };
</script>
